/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.FlashMessages')
    .directive('accFlash', ['flashMessagesService', '$timeout', function (flashMessagesService, $timeout) {
        var SHOW_MORE_BUTTON_WIDTH_PX = 150,
            LETTER_AVARAGE_WIDTH_PX = 8,
            TRIMMED_END_CHARACTERS = ['.', '!', ',', ':', ';', '-'];

        return {
            replace: true,
            scope: {},
            template: '<div id="flash-container" ng-hide="!flash.any()">\
            <div class="alert alert-{{flash.getCurrent().cssClass}} alert-dismissable {{flash.count() == 1 ? \'wider\' : \'\'}}"\
            ng-class="{expanded: expanded}" ng-if="flash.any()">\
                <div class="nav" ng-hide="flash.count() == 1">\
                    <i class="nav-prev icon-acc-left_arrow" ng-click="flash.previous()" ng-disabled="flash.getPublicIndex() <= 1"></i> \
                    {{flash.getPublicIndex()}} / {{flash.count()}} \
                    <i class="nav-next icon-acc-right_arrow" ng-click="flash.next()" ng-disabled="flash.getPublicIndex() >= flash.count()"></i>\
                </div>\
                <i class="icon-acc-cross close" ng-click="flash.remove();" ng-if="flash.getCurrent().type != \'success\'"></i>\
                \
                <span class="wrapper-icon">\
                    <i class="notification-icon icon-acc-good"></i>\
                    <i class="notification-icon icon-acc-info"></i>\
                    <i class="notification-icon icon-acc-error"></i>\
                    <i class="notification-icon icon-acc-warning"></i>\
                </span>\
                <span class="wrapper-text">\
                    <span>{{ getMessage() }}</span>\
                    <a href ng-click="expand()" ng-show="trimmed && !expanded">{{ \'Show more\' | translate}}</a>\
                </span> \
            </div>\
        </div>',
            link: function ($scope, $element) {
                var maxLength;

                $scope.$on('windowResize', function () {
                    $scope.flash.reload();
                    $scope.$apply();
                });

                $scope.flash = flashMessagesService;

                $scope.expanded = false;

                $scope.$watch('flash.any()', function (hasAny) {
                    if (hasAny) {
                        $timeout(function () {
                            maxLength = Math.floor(($element.find('.alert').width() - SHOW_MORE_BUTTON_WIDTH_PX) / LETTER_AVARAGE_WIDTH_PX);
                        });
                    }
                });

                $scope.$watch('flash.getCurrent()', function () {
                    $scope.expanded = false;
                });

                $scope.getMessage = function () {
                    $scope.trimmed = (maxLength && maxLength < $scope.flash.getCurrent().text.length);

                    if ($scope.trimmed && !$scope.expanded) {
                        var trimmed = $scope.flash.getCurrent().text.substring(0, maxLength);
                        trimmed = trimmed.substr(0, Math.min(trimmed.length, trimmed.lastIndexOf(" ")));
                        return $.inArray(trimmed[trimmed.length - 1], TRIMMED_END_CHARACTERS) != -1 ? trimmed.substr(0, trimmed.length - 1) : trimmed;
                    } else {
                        return $scope.flash.getCurrent().text;
                    }
                };

                $scope.expand = function () {
                    $scope.expanded = true;
                };
            }
        }
    }]);
